module.exports = __webpack_public_path__ + "4382d3bec360c5c1657803c40291a79e.woff2";